"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Caption = void 0;

var react_1 = __importDefault(require("react"));

var identity_1 = require("../../identity");

var Caption = function Caption(_a) {
  var children = _a.children,
      _b = _a.marginBottom,
      marginBottom = _b === void 0 ? false : _b,
      _c = _a.marginTop,
      marginTop = _c === void 0 ? false : _c,
      _d = _a.paddingBottom,
      paddingBottom = _d === void 0 ? false : _d,
      _e = _a.paddingTop,
      paddingTop = _e === void 0 ? false : _e,
      _f = _a.theme,
      theme = _f === void 0 ? identity_1.ThemeLight : _f;
  var style = "w-full " + (theme ? theme.body.textSecondaryColor : 'text-gray-500') + " " + identity_1.defCaption + " " + (0, identity_1.defTextMargin)(marginBottom, marginTop) + " " + (0, identity_1.defTextPadding)(paddingBottom, paddingTop);
  return react_1["default"].createElement("figcaption", {
    className: style
  }, children);
};

exports.Caption = Caption;